import {get, post, del, patch, download, upload} from "../api"
import * as url from "../url"
import { format } from 'react-string-format';

const apiGetAnalyticalAccountsList = data => {
  return get(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS, data.companyId), data.history)
}

const apiPostAnalyticalAccountsNew = data => {
  return post(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS, data.companyId), data.history, data.values)
}

const apiPatchAnalyticalAccountsEdit = data => {
  return patch(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS_DETAIL, data.companyId, data.analyticalAccountId), data.history, data.values)
}

const apiDeleteAnalyticalAccountsDelete = data => {
  return del(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS_DETAIL, data.companyId, data.analyticalAccountId), data.history)
}

const apiDownloadCompaniesExportAccounts = data => {
  return download(url.API_ANALYTICAL_ACCOUNTS + "export-accounts/", data.history, "accounts.csv")
}

const apiUploadCompaniesImportAccounts = data => {
  return upload(url.API_ANALYTICAL_ACCOUNTS + "import-accounts/", data.history, data.file, {headers: {'Content-Type': 'multipart/form-data'}})
}

export {
  apiGetAnalyticalAccountsList,
  apiPostAnalyticalAccountsNew,
  apiPatchAnalyticalAccountsEdit,
  apiDeleteAnalyticalAccountsDelete,
  apiDownloadCompaniesExportAccounts,
  apiUploadCompaniesImportAccounts,
}
